module.exports = __webpack_public_path__ + "static/11-077daaa98067c8bef22840310d7ff123.png";